<template>
    <DashboardCard
            :width="width"
            :dataDisplay="dataDisplay"
            :main_icon="main_icon"
            :bgColor="bgColor"
            :icons="icon_data"
            :load_url="load_url"
            :base-col-len="12"
            :hasLinks="hasLinks"
            :title="title">
    </DashboardCard>
</template>

<script>
    import DashboardCard from '../../widgets/DashboardCard';
    export default {
        name: 'ProcessingFlags',
        components: {DashboardCard},
        props: {
            dataDisplay: {type:String, default: null},
            bgColor: {type: String, default: 'light'},
            width: {type: Number, default: 25}
        },
        data() {
            return {
                hasLinks: true,
                main_icon: 'fa-light fa-flag',
                color: '#d53a00',
                title: 'Processing Flags',
                load_url: '/dashboards/ProcessingFlags',
                icon_data: [
                    {
                        name: 'Out for Estimate - Diamond',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=10&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14&filterField_5=status_id&filterModel_5=order&filterName_5=Order%20Status&filterParameter_5=not%20equal%20to&filterValue_5=9',
                        text_color: '#555'
                    },
                    {
                        name: 'Out for Estimate - Watch',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=11&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14&filterField_5=status_id&filterModel_5=order&filterName_5=Order%20Status&filterParameter_5=not%20equal%20to&filterValue_5=9',
                        text_color: '#555'
                    },
                    {
                        name: 'Out for Estimate - Coin',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=54&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14&filterField_5=status_id&filterModel_5=order&filterName_5=Order%20Status&filterParameter_5=not%20equal%20to&filterValue_5=9',
                        text_color: '#555'
                    },
                    {
                        name: 'Permission to Alter',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=12',
                        text_color: '#555'
                    },
                    {
                        name: 'Proof Of Ownership',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=18',
                        text_color: '#555'
                    },
                    {
                        name: 'PTA + Proof Of Ownership',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=19',
                        text_color: '#555'
                    },
                    // {
                    //     name: 'Brand Packaging',
                    //     url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=26&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14',
                    //     text_color: '#555'
                    // },
                    // {
                    //     name: 'Previously Negotiated',
                    //     url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=29',
                    //     text_color: '#555'
                    // },
                    {
                        name: 'Shipping Delay',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=55&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=equals&filterValue_1=3',
                        text_color: '#555'
                    },
                    {
                        name: 'Priority Processing',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=34&filterField_1=status_id&filterModel_1=order&filterName_1=Order%20Status&filterParameter_1=not%20equal%20to&filterValue_1=12&filterField_2=status_id&filterModel_2=order&filterName_2=Order%20Status&filterParameter_2=not%20equal%20to&filterValue_2=13&filterField_3=status_id&filterModel_3=order&filterName_3=Order%20Status&filterParameter_3=not%20equal%20to&filterValue_3=15&filterField_4=status_id&filterModel_4=order&filterName_4=Order%20Status&filterParameter_4=not%20equal%20to&filterValue_4=14',
                        text_color: '#d53a00'
                    },
                    {
                        name: 'Re-Appraise',
                        url: '/search?filterField_0=flag_type_id&filterModel_0=order_flags&filterName_0=Flag&filterParameter_0=equals&filterValue_0=4',
                        text_color: '#d53a00'
                    },
                ],
            };
        },
    };
</script>

<style scoped>

</style>